import { TypedDocumentNode, gql } from '@apollo/client';

import { updateManagerTeamInput } from '@sorare/core/src/__generated__/globalTypes';
import { useMutation } from '@sorare/core/src/hooks/graphql/useMutation';

import {
  UpdateManagerTeamMutation,
  UpdateManagerTeamMutationVariables,
} from './__generated__/useUpdateManagerTeam.graphql';

const UPDATE_MANAGER_TEAM_MUTATION = gql`
  mutation UpdateManagerTeamMutation(
    $input: updateManagerTeamInput!
    $so5LeagueSlug: String!
    $withSo5League: Boolean!
  ) {
    updateManagerTeam(input: $input) {
      managerTeam {
        id
        name
        hidden
        so5Leaderboard(so5LeagueSlug: $so5LeagueSlug)
          @include(if: $withSo5League) {
          slug
          so5League {
            slug
            mySo5LeaderboardContenders {
              slug
            }
          }
          so5LeaderboardGroup {
            slug
            mySo5LeaderboardContenders {
              slug
            }
          }
        }
      }
      errors {
        path
        message
        code
      }
    }
  }
` as TypedDocumentNode<
  UpdateManagerTeamMutation,
  UpdateManagerTeamMutationVariables
>;

export const useUpdateManagerTeam = () => {
  const [mutate, { loading }] = useMutation(UPDATE_MANAGER_TEAM_MUTATION, {
    showErrorsWithSnackNotification: true,
  });

  return {
    updateManagerTeam: async (
      input: updateManagerTeamInput,
      so5LeagueSlug?: string
    ) =>
      mutate({
        variables: {
          input,
          so5LeagueSlug: so5LeagueSlug || '',
          withSo5League: !!so5LeagueSlug,
        },
      }),
    loading,
  };
};
